import dayjs from 'dayjs'

import { DateField } from '@prismicio/client'

import { WhatsNewDocument } from '../model/types'

export type DateType = Date | string

export const getFirstTitle = (document: WhatsNewDocument): string => document.data?.title?.[0]?.text || ''

export const getDocumentDate = (document?: WhatsNewDocument): string | undefined =>
  document && dayjs(document.data.date).toISOString()

export const localeToPrismicLang = (locale: string) => locale.replace('_', '-').toLowerCase()

export const printDate = (date: DateField, format: string = 'LL', fallBack: string = '-'): string => {
  const dayjsDate = dayjs(date)
  return date && dayjsDate.isValid() ? dayjsDate.format(format) : fallBack
}
